var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"v2026-loading",style:({ color: _vm.color })},[_c('span',{staticClass:"v2026-loading__spinner",attrs:{"aria-hidden":"true"}}),(_vm.label)?_c('span',{staticClass:"v2026-loading__label"},[_vm._v(_vm._s(_vm.label)),(_vm.dots)?_c('span',{staticClass:"v2026-loading__dots"},[_c('i'),_c('i'),_c('i')]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }